const CENTS_FACTOR = 100;

function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

export function toPriceCentValue(price: number | null | undefined): number | null {
  if (!isFiniteNumber(price)) {
    return null;
  }

  return Math.round(price * CENTS_FACTOR);
}

export function toPriceDisplayValue(priceCent: number | null | undefined): number | null {
  if (!isFiniteNumber(priceCent)) {
    return null;
  }

  return priceCent / CENTS_FACTOR;
}

export function resolveEvaluationPriceValue(
  price: number | null | undefined,
  priceCent: number | null | undefined,
): number | null {
  return toPriceDisplayValue(priceCent) ?? (isFiniteNumber(price) ? price : null);
}

export function buildUpdatePricePayload<T extends { price?: number | null; priceCent?: number | null }>(
  payload: T,
): Omit<T, 'price'> & { priceCent?: number } {
  const { price, ...rest } = payload;
  const normalizedPriceCent = payload.priceCent ?? toPriceCentValue(price);

  if (normalizedPriceCent === null) {
    return {
      ...rest,
      priceCent: undefined,
    };
  }

  return {
    ...rest,
    priceCent: normalizedPriceCent,
  };
}